import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';
import { menuApiService } from 'services/menuApiService';

const UpdateProductModal = ({
  isOpen,
  toggle,
  product,
  onUpdateSuccess
}) => {
  const [formData, setFormData] = useState({
    item_name: '',
    description: '',
    category: '',
    price: '',
    discount: '',
    quantity: '',
    productbrand: '',
    size: '',
    origin: '',
    image1: null,
  });
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState('');

  useEffect(() => {
    if (product) {
      setFormData({
        item_name: product.item_name || '',
        description: product.description || '',
        category: product.category || '',
        price: product.price || '',
        discount: product.discount || '',
        quantity: product.quantity || '',
        productbrand: product.productbrand || '',
        size: product.size || '',
        origin: product.origin || '',
        image1: null,
      });
      setImagePreview(product.image1 || '');
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        image1: file
      }));

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const dataToSend = new FormData();
      dataToSend.append('item_name', formData.item_name);
      dataToSend.append('description', formData.description);
      dataToSend.append('category', formData.category);
      dataToSend.append('price', formData.price);
      dataToSend.append('discount', formData.discount);
      dataToSend.append('quantity', formData.quantity);
      dataToSend.append('productbrand', formData.productbrand);
      dataToSend.append('size', formData.size);
      dataToSend.append('origin', formData.origin);
      if (formData.image1) {
        dataToSend.append('image1', formData.image1);
      }

      await menuApiService.updateProduct(product.id, dataToSend);

      onUpdateSuccess();
      toggle();
    } catch (error) {
      console.error('Error updating product:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Update Product</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label for="item_name">Product Name *</Label>
                <Input
                  type="text"
                  id="item_name"
                  name="item_name"
                  value={formData.item_name}
                  onChange={handleChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="discount">Discount (%)</Label>
                <Input
                  type="number"
                  id="discount"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  min="0"
                  max="100"
                />
              </FormGroup>

              <FormGroup>
                <Label for="description">Description</Label>
                <Input
                  type="textarea"
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                />
              </FormGroup>




            </div>

            <div className="col-md-6">
              <FormGroup>
                <Label for="price">Price *</Label>
                <Input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                  min="0"
                  step="0.01"
                />
              </FormGroup>



              {/* <FormGroup>
                <Label for="quantity">Quantity</Label>
                <Input
                  type="number"
                  id="quantity"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  min="0"
                />
              </FormGroup> */}

              {/* <FormGroup>
                <Label for="productbrand">Brand</Label>
                <Input
                  type="text"
                  id="productbrand"
                  name="productbrand"
                  value={formData.productbrand}
                  onChange={handleChange}
                />
              </FormGroup> */}

              <FormGroup>
                <Label for="image1">Product Image</Label>
                <Input
                  type="file"
                  id="image1"
                  name="image1"
                  onChange={handleFileChange}
                  accept="image/*"
                />
                <FormText>
                  Leave empty to keep current image
                </FormText>

                {imagePreview && (
                  <div className="mt-2">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                      }}
                    />
                  </div>
                )}
              </FormGroup>

              {/* <FormGroup>
                <Label for="category">Category *</Label>
                <Input
                  type="select"
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="appetizer">Appetizers</option>
                  <option value="main course">Main Dish</option>
                  <option value="fast food">Sides / Extra</option>
                  <option value="dessert">Dessert</option>
                </Input>
              </FormGroup> */}

            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1"></span>
                Updating...
              </>
            ) : (
              'Update Product'
            )}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default UpdateProductModal;